import React, { useEffect, useState } from "react";
import { WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography/Typography";
import { styles } from "./OrderDetailsView.styles";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import ToastStatusEnum from "../../constants/ToastStatusEnum";
import { IRemoteDataTableColumn } from "../components/RemoteDataTable/interfaces";
import { CenteredContainer } from "../components/CenteredContainer/CenteredContainer";
import TableRemoteData, { getParamsFromQuery } from "../components/RemoteDataTable/RemoteDataTable";
import { requestPublicLinkFiles } from "../components/RemoteDataTable/requests";

export interface IPublicLinkDownloadViewProps extends WithStyles<typeof styles> {}

const PublicLinkDownloadViewPure: React.FunctionComponent<IPublicLinkDownloadViewProps> = ({
    classes
}: IPublicLinkDownloadViewProps) => {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const { publicLinkId } = useParams();
    const [isData, setIsData] = useState<boolean>(false);

    useEffect(() => {
        requestPublicLinkFiles(publicLinkId, { limit: 1 })
            .then(response => {
                setIsData(true);
            })
            .catch(e => setIsData(false));
    }, [publicLinkId]);

    const filescolumns: IRemoteDataTableColumn[] = [
        {
            type: "text",
            title: t("general.filename"),
            field: "filename"
        },
        {
            type: "size",
            title: t("general.size"),
            field: "size"
        },
        {
            title: t("general.download"),
            type: "link",
            sortDisable: true,
            linkField: "link",
            linkTitle: t("general.download")
        }
    ];

    const handleData = query => {
        return new Promise((resolve, reject) => {
            const params = getParamsFromQuery(query);

            requestPublicLinkFiles(publicLinkId, params)
                .then(response => {
                    resolve({
                        data: response.data.content || [],
                        page: query.page,
                        totalCount: response.data.totalCount
                    });
                })
                .catch(error => {
                    enqueueSnackbar("List of files cannot be loaded: " + error, {
                        variant: ToastStatusEnum.Error
                    });
                    reject(error);
                });
        });
    };

    return (
        <CenteredContainer>
            <div className={classes.orderTitle}>
                <Typography variant="h2">Download files</Typography>
            </div>
            <div>
                {isData ? (
                    <TableRemoteData
                        columns={filescolumns}
                        onQueryChange={handleData}
                        emptyDataMessage={"No files available."}
                    />
                ) : (
                    <Typography variant="h4">Download link is not valid</Typography>
                )}
            </div>
        </CenteredContainer>
    );
};

export const PublicLinkDownloadView = withStyles(styles)(PublicLinkDownloadViewPure);
